<template>
    <window :title="title">
        <span v-show="display.mobile.value"
            >※ スマホ使用時は横向き表示推奨</span
        >
        <table class="table table-bordered">
            <thead style="background: #ffccff">
                <tr>
                    <th>項目</th>
                    <th>基礎知識編</th>
                    <th>ストーリー編</th>
                    <th>テスト編</th>
                </tr>
            </thead>
            <tbody>
                <tr>
                    <td>
                        <router-link to="/menu/pswd"
                            >①パスワード設定</router-link
                        >
                    </td>
                    <td>
                        {{ calcStatus("pswd", "base") }}
                    </td>
                    <td>
                        {{ calcStatus("pswd", "story") }}
                    </td>
                    <td>
                        {{ calcStatus("pswd", "test") }}
                    </td>
                </tr>
                <tr>
                    <td>
                        <router-link to="/menu/mail">②メール利用</router-link>
                    </td>
                    <td>
                        {{ calcStatus("mail", "base") }}
                    </td>
                    <td>
                        {{ calcStatus("mail", "story") }}
                    </td>
                    <td>
                        {{ calcStatus("mail", "test") }}
                    </td>
                </tr>
                <tr>
                    <td>
                        <router-link to="/menu/web">③ウェブ利用</router-link>
                    </td>
                    <td>
                        {{ calcStatus("web", "base") }}
                    </td>
                    <td>
                        {{ calcStatus("web", "story") }}
                    </td>
                    <td>
                        {{ calcStatus("web", "test") }}
                    </td>
                </tr>
                <tr>
                    <td>
                        <router-link to="/menu/information"
                            >④情報漏洩</router-link
                        >
                    </td>
                    <td>
                        {{ calcStatus("information", "base") }}
                    </td>
                    <td>
                        {{ calcStatus("information", "story") }}
                    </td>
                    <td>
                        {{ calcStatus("information", "test") }}
                    </td>
                </tr>
                <tr>
                    <td>
                        <router-link to="/menu/incident"
                            >⑤インシデント対応</router-link
                        >
                    </td>
                    <td>
                        {{ calcStatus("incident", "base") }}
                    </td>
                    <td>
                        {{ calcStatus("incident", "story") }}
                    </td>
                    <td>
                        {{ calcStatus("incident", "test") }}
                    </td>
                </tr>
            </tbody>
        </table>

        <div>〇：学習済み/合格，―：未学習，×：不合格</div>
        <button
            class="btn btn-sm btn-danger"
            @click="$store.commit('clearCache')"
        >
            学習履歴のクリア
        </button>
        <!-- <div><a href="last.php">前回の学習項目へ</a></div>
            <div><a href="question.php">アンケート</a></div> -->
        <hr />
        このページはCookieを利用して進捗状況等を管理しています。<br />
        Cookieが無効の場合は学習状況表示が全て未学習になり，<br />
        前回の続きから学習する機能は利用できません。<br />
        <hr />
        参考サイト
        <div>
            〇
            <a href="https://www.ipa.go.jp/security/keihatsu/sme/guideline/"
                >中小企業の情報セキュリティ対策ガイドライン</a
            >
        </div>
        <div>
            〇
            <a
                href="https://www.jnsa.org/result/incident/data/2016incident_survey_ver1.2.pdf"
                >2016年情報セキュリティインシデントに関する調査報告書～個人情報漏えい～
            </a>
        </div>
    </window>
</template>

<script>
import { mapGetters } from "vuex";
import { useDisplay } from "vuetify/lib/composables/display";

export default {
    name: "base_home",
    setup() {
        const display = useDisplay();
        return { display };
    },
    data() {
        return {
            title: "学習項目一覧",
        };
    },
    computed: {
        // mix the getters into computed with object spread operator
        ...mapGetters([
            "getStatusIncident",
            "getStatusWeb",
            "getStatusInformation",
            "getStatusMail",
            "getStatusPassword",
        ]),
    },
    methods: {
        calcStatus(contents, prop) {
            let status = null;
            if (contents == "mail") status = this.getStatusMail();
            else if (contents == "web") status = this.getStatusWeb();
            else if (contents == "information")
                status = this.getStatusInformation();
            else if (contents == "pswd") status = this.getStatusPassword();
            else if (contents == "incident") status = this.getStatusIncident();
            if (status[prop].lastStudyTime == "") return "―";
            if (status[prop].isComplete) return "〇";
            else return "×";
        },
    },
};
</script>
